import { render, staticRenderFns } from "./im.vue?vue&type=template&id=9854c572&scoped=true"
import script from "./im.vue?vue&type=script&lang=js"
export * from "./im.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9854c572",
  null
  
)

export default component.exports